import { Reseller } from 'api/contentful/contentTypes.cloverdotcom';
import { Entry } from 'contentful';
import { useEffect } from 'react';
import { IntercomWrapper } from 'services/intercom';
import { getField } from 'utils/EntryUtil';
import { setStorageReseller } from './util';

/**
 * This hook handles the logic for setting the reseller in local storage and enabling/disabling Intercom.
 *
 * @param contentfulReseller - The Reseller entry from Contentful
 * @param referralId - The referralId for the Reseller from DCS
 */
export const useResellerStorage = (contentfulReseller?: Entry<Reseller>, referralId = '') => {
  useEffect(() => {
    setStorageReseller(referralId, contentfulReseller);

    const isLiveChatEnabled = !contentfulReseller || !!getField(contentfulReseller, 'isLiveChatEnabled');
    if (isLiveChatEnabled) {
      return IntercomWrapper.enableAndShow();
    }
    IntercomWrapper.shutdown();
  }, [contentfulReseller, referralId]);
};
